import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8965%3A20710
 *
 * @param {SvgIconProps} props - svg props
 */
export const BlockButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M11.9999 18.6666C15.6818 18.6666 18.6666 15.6818 18.6666 11.9999C18.6666 8.31802 15.6818 5.33325 11.9999 5.33325C8.31802 5.33325 5.33325 8.31802 5.33325 11.9999C5.33325 15.6818 8.31802 18.6666 11.9999 18.6666ZM15.938 15.0811C16.6033 14.232 16.9999 13.1622 16.9999 11.9999C16.9999 9.23844 14.7614 6.99986 11.9999 6.99986C11.1331 6.99986 10.3178 7.22046 9.60702 7.60858L15.4683 14.4397L15.938 15.0811ZM14.7681 16.1643C14.7285 16.1451 14.6923 16.1179 14.662 16.083L8.24764 8.69519C7.47106 9.57628 6.99994 10.7331 6.99994 11.9999C6.99994 14.7613 9.23852 16.9999 11.9999 16.9999C13.0237 16.9999 13.9755 16.6922 14.7681 16.1643Z' fill='white'/>
        </SvgIcon>
    )
}

export default BlockButtonIcon
